

export default function isApplicant({ next, store, nextMiddleware }) {

  if (!store.GET_VALID('applicant')) {
    return next({
      name: "insurance.applicant",
    });
  }

  return nextMiddleware();
}
